/* AIVIQ homepage: »Find din espressomaskine«, six machines, four questions (sections/aiviq-home-finder.liquid).
   Rules and copy: pdp/research/quiz-r8.md. §2 the flow (one fork, two questions per branch, budget last), §3 the
   scoring, §4 the result card (one match, three reasons, one honest note, one alternative), §5 the budget chips
   (made from the live prices). Prices, stock, links and pictures come from the JSON the section prints. */
(function () {
  const root = document.querySelector('[data-af]');
  if (!root || root.dataset.afReady) return;
  root.dataset.afReady = '1';
  let DATA;
  try { DATA = JSON.parse(root.querySelector('[data-af-data]').textContent).machines; } catch (e) { return; }
  const quiz = root.querySelector('[data-af-quiz]');
  const NB = ' ';
  const kr = (ore) => Math.round(ore / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + NB + 'kr';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const LADDER = { hands: ['core', 'brew', 'advanced', 'expert'], touch: ['lumina', 'aem'] };
  const ok = (k) => DATA[k] && DATA[k].ok && DATA[k].available !== false;
  const inPlay = (g) => LADDER[g].filter(ok);

  /* ---------- the questions (§2.2) ---------- */
  const Q = {
    q1: { title: 'Hvordan vil du lave kaffen?', opts: [
      ['touch', 'Med ét tryk', 'Maskinen maler, brygger og skummer mælken for dig.'],
      ['hands', 'Selv, som en barista', 'Du maler kaffen, trykker den ned og skummer mælken.']],
      more: 'Med ét tryk laver maskinen hele koppen: den maler bønnerne, brygger og skummer mælken. Med en Aspire laver du den selv: kværnen er bygget ind, og du trykker kaffen ned, brygger og skummer mælken. Aspire-serien kan du prøve derhjemme i 30 dage.' },
    q2h: { title: 'Hvad skal den lave?', opts: [
      ['espresso', 'Espresso og sort kaffe', 'Sjældent med mælk'],
      ['one', 'Én mælkedrik ad gangen', 'En cappuccino eller latte til dig'],
      ['many', 'Mælkedrikke til flere', 'To eller flere efter hinanden'],
      ['filter', 'Også filterkaffe eller cold brew', 'Pour-over i weekenden eller kaffe over is']] },
    q3h: { title: 'Hvor meget vil du selv styre?', opts: [
      ['simple', 'Få knapper', 'Jeg smager mig frem'],
      ['numbers', 'Et display med tallene', 'Jeg retter én ting ad gangen'],
      ['guide', 'En skærm, der viser vejen', 'Trin for trin, mens jeg lærer det'],
      ['full', 'Det hele', 'Gram, grader og tryk']] },
    q2t: { title: 'Hvor mange drikker kaffe hjemme hos jer?', opts: [
      ['few', 'Én eller to', 'Et par kopper om dagen'],
      ['many', 'Tre eller flere', 'Eller I har tit gæster']] },
    q3t: { title: 'Hvor meget må den fylde?', opts: [
      ['narrow', 'Så lidt som muligt', 'En smal maskine, ca. 20' + NB + 'cm bred'],
      ['room', 'Den må gerne være bredere', 'Ca. 30' + NB + 'cm er fint']] },
  };
  /* points: question option × machine (§3.2) */
  const POINTS = {
    q2h: { espresso: { core: 2 }, one: { core: 2, brew: 1 }, many: { brew: 2, advanced: 2, expert: 2 }, filter: { expert: 5 } },
    q3h: { simple: { core: 2, brew: 2 }, numbers: { advanced: 3, expert: 2 }, guide: { core: 1, brew: 1, expert: 4 }, full: { advanced: 3, expert: 4 } },
    q2t: { few: { lumina: 2 }, many: { aem: 2 } },
    q3t: { narrow: { lumina: 3 }, room: { aem: 1 } },
  };

  /* ---------- the result copy (§4.2, §4.3) ---------- */
  const TRIAL = 'Ikke sikker endnu? Du kan bruge den derhjemme i 30 dage.';
  const COPY = {
    core: { why: 'Espresso fra bunden, i dit eget tempo.',
      lines: { espresso: ['Espresso og sort kaffe: varmt vand til americano kommer fra dampstaven.'], one: ['Én mælkedrik ad gangen: du brygger espressoen og skummer mælken bagefter.'], simple: ['Få knapper: kværn og kop har hver deres knap, og de husker din mængde.'], guide: ['En rolig start: fire faste temperaturer og få ting at indstille.'] },
      budget: 'Under {cap}: samme kværn og samme PID som Brew og Advanced.',
      defaults: ['Kværnen er bygget ind, så bønnerne males lige før koppen.', 'Temperaturen holdes stabil med PID, så kop nummer to smager som den første.'],
      good: () => 'Den brygger først og skummer mælken bagefter.',
      also: { brew: 'Laver I flere mælkedrikke efter hinanden, skummer den mælk, mens espressoen løber.' },
      step: 'samme kværn og samme PID med få knapper' },
    brew: { why: 'Til morgener, hvor der skal laves mere end én kop.',
      lines: { many: ['Mælkedrikke til flere: to varmesystemer, så du skummer mælk, mens espressoen løber.'], one: ['Én mælkedrik ad gangen: mælken kan skummes, mens espressoen løber.'], simple: ['Få knapper: alt sidder på fronten, og der er ingen menuer.'], guide: ['En rolig start: fire faste temperaturer og få ting at indstille.'] },
      budget: 'Under {cap}: samme kværn og samme PID som Core og Advanced.',
      defaults: ['Kværnen er bygget ind, så bønnerne males lige før koppen.', 'Temperaturen holdes stabil med PID, så kop nummer to smager som den første.'],
      good: () => 'Fire faste temperaturer og intet display, så du smager dig frem.',
      also: { core: 'Laver I én mælkedrik ad gangen, er den nok: den brygger først og skummer bagefter.', advanced: 'Vil du se tallene, har den et display med bryggetid og temperatur i trin på 1' + NB + '°C.' },
      step: 'to varmesystemer, så den skummer mælk, mens espressoen løber' },
    advanced: { why: 'Du justerer én ting ad gangen og ser, hvad det gør ved koppen.',
      lines: { numbers: ['Et display med tallene: det viser bryggetiden, mens espressoen løber.', 'Grad for grad: temperaturen i trin på 1' + NB + '°C og en forbrygning, der fugter kaffen først.'], many: ['Mælkedrikke til flere: den skummer mælk, mens espressoen løber.'], one: ['Én mælkedrik ad gangen: mælken kan skummes, mens espressoen løber.'], espresso: ['Espresso og sort kaffe: varmt vand til americano kommer fra sit eget udløb.'], full: ['Det meste selv: temperatur, forbrygning og mængde efter dit valg.'] },
      budget: 'Under {cap}: display, temperatur i trin på 1' + NB + '°C og eget udløb til varmt vand.',
      defaults: ['Temperaturen holdes stabil med PID, så kop nummer to smager som den første.'],
      good: () => 'Det tager lidt øvelse at finde kværningen. Displayet viser dig, hvad du ændrer.',
      also: { expert: 'Vil du gentage koppen ned til grammet, har den en vægt i kværnholderen og gemmer dine opskrifter.', brew: 'Den skummer også mælk, mens espressoen løber, men uden display: du smager dig frem.', core: 'Samme kværn og samme PID, med få knapper i stedet for et display.' },
      step: 'et display med bryggetid og temperatur i trin på 1' + NB + '°C' },
    expert: { why: 'Hjælp på travle morgener og fuld kontrol i weekenden.',
      lines: { guide: ['En skærm, der viser vejen: i Simple Mode følger du trinene på skærmen.', 'Hjælp til kværnen: den kan sige til, når kværnen skal justeres.'], full: ['Det hele: i Expert Mode sætter du tryk og tid i op til fire trin.', 'Gram: vægten i kværnholderen viser dosen, mens kværnen kører.'], numbers: ['Tallene: skærmen viser trykkurven, og vægten viser grammene.'], many: ['Mælken: du vælger 40–⁠70' + NB + '°C, og dampen stopper selv ved den temperatur.'], one: ['Mælken: du vælger 40–⁠70' + NB + '°C, og dampen stopper selv ved den temperatur.'], filter: ['Filterkaffe og cold brew: egne programmer, og til pour-over hælder den vandet i trin.'], espresso: ['Espresso og sort kaffe: varmt vand til americano kommer fra sit eget udløb.'], simple: ['Få tryk: i Simple Mode vælger du drikken og følger trinene.'] },
      defaults: ['Egne opskrifter: gem koppen, når den smager, som den skal.', 'Temperaturen holdes stabil med PID, så kop nummer to smager som den første.'],
      good: () => 'Du holder selv kanden, og alt styres på skærmen.',
      also: { advanced: 'Er knapper og et display nok, viser den også bryggetid og temperatur.', brew: 'Vil du hellere have knapper end en skærm, skummer den også mælk, mens espressoen løber.', core: 'Vil du hellere lære med få knapper, hjælper filmene og serviceteamet dig i gang.' },
      step: 'touchskærm, vægt i kværnholderen og dampstav med temperaturføler' },
    lumina: { why: 'Hver sin kop på ét tryk, fra en maskine, der kun er 19,9' + NB + 'cm bred.',
      lines: { few: ['Én eller to: 1,2' + NB + 'L vandtank og 100' + NB + 'g bønner i toppen.'], narrow: ['Så lidt som muligt: 19,9' + NB + 'cm bred, 40,3' + NB + 'cm dyb og 31,7' + NB + 'cm høj.'] },
      budget: 'Under {cap}: mælkedrikke på ét tryk, ligesom på AEM-101S.',
      defaults: ['Ni drikke på skærmen, fra espresso til flat white.', 'Mælken skummes lige ned i glasset, og skummet kan gøres tykkere eller tyndere.', 'Hver drik kan rettes til, og maskinen husker den til næste gang.'],
      good: (a) => (a.q2 === 'many' ? 'Med 1,2' + NB + 'L vand og 100' + NB + 'g bønner fylder du op oftere, når I er flere.' : 'Brugervejledningen beder om 10' + NB + 'cm fri luft rundt om maskinen.'),
      also: { aem: 'Er I flere, har den 1,8' + NB + 'L vandtank, 160' + NB + 'g bønner og mælk direkte fra kartonen.' },
      step: 'en bredde på 19,9' + NB + 'cm og mælkedrikke på ét tryk' },
    aem: { why: 'Otte kaffedrikke på ét tryk, til hele huset.',
      lines: { many: ['Tre eller flere: 1,8' + NB + 'L vandtank og 160' + NB + 'g bønner, så du fylder sjældnere op.'], room: ['Gerne bredere: en stor touchskærm, og de fleste drikke findes også som dobbelt.'] },
      defaults: ['Mælken direkte fra kartonen: sæt slangen i, og vælg drikken.', 'Koffeinfri til én: kom en skefuld formalet kaffe i tragten.', 'Hver drik efter jeres smag: 7–⁠12' + NB + 'g kaffe og 75–⁠95' + NB + '°C.'],
      good: () => 'Den er 28,3' + NB + 'cm bred og 46,3' + NB + 'cm dyb. Hold 5' + NB + 'cm fri til væggen bag og ved siden af.',
      also: { lumina: 'Er pladsen smal, er den 19,9' + NB + 'cm bred og laver også mælkedrikke på ét tryk.' },
      step: '1,8' + NB + 'L vandtank, 160' + NB + 'g bønner og mælk direkte fra kartonen' },
  };
  const TRUST = {
    hands: ['Prøv den derhjemme i 30 dage.', 'Passer en anden Aspire bedre, kan du bytte, og AIVIQ betaler returfragten ved ombytning.'],
    touch: '30 dages returret. Du får pengene retur, også hvis maskinen er brugt, når den er rengjort og sendt i den originale emballage. Hjemmeprøven gælder Aspire-serien.',
  };

  /* ---------- state ---------- */
  const SKIP = 'skip';
  let a = {};          /* q1, q2, q3, q4 (q4: a cap in øre, 'any' or 'skip'); the other branch's answers stay in mem */
  const mem = { hands: {}, touch: {} };
  let step = 0;        /* 0..3 = question, 4 = result */
  let moreOpen = false;
  const group = () => (a.q1 === 'touch' ? 'touch' : 'hands');
  const qKey = (i) => (i === 0 ? 'q1' : i === 3 ? 'q4' : 'q' + (i + 1) + (group() === 'touch' ? 't' : 'h'));
  const caps = () => {
    const c = [...new Set(inPlay(group()).map((k) => Math.ceil(DATA[k].price / 100000) * 100000))].sort((x, y) => x - y);
    c.pop();
    return c.slice(0, 3);
  };
  const track = (name, detail) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, detail)); } catch (e) {} };

  /* ---------- scoring (§3.3) ---------- */
  const score = (k) => {
    const g = group();
    let s = 0;
    ['q2', 'q3'].forEach((q) => { const t = POINTS[q + (g === 'touch' ? 't' : 'h')][a[q]]; if (t && t[k]) s += t[k]; });
    return s;
  };
  const compute = () => {
    const g = group();
    const all = inPlay(g);
    const cap = typeof a.q4 === 'number' ? a.q4 : null;
    let under = cap ? all.filter((k) => DATA[k].price <= cap) : all.slice();
    if (!under.length) under = all.slice(0, 1);
    const best = Math.max(...under.map(score));
    const tied = under.filter((k) => score(k) === best);
    const byPrice = (x, y) => DATA[x].price - DATA[y].price;
    const match = cap ? tied.sort(byPrice)[tied.length - 1] : tied.sort(byPrice)[0];
    const pos = (k) => LADDER[g].indexOf(k);
    const nearest = (list) => list.slice().sort((x, y) => Math.abs(pos(x) - pos(match)) - Math.abs(pos(y) - pos(match)) || byPrice(x, y))[0];
    const top = (list) => { const m = Math.max(...list.map(score)); return nearest(list.filter((k) => score(k) === m)); };
    let runner = null;
    let kind = 'also';
    const skipped1 = a.q1 === SKIP || a.q1 === undefined;
    const above = cap ? all.filter((k) => DATA[k].price > cap) : [];
    const better = above.filter((k) => score(k) > best);
    const capDecided = better.length > 0 || (cap && best === 0);
    if (skipped1) {
      const want = a.q2 === 'many' ? 'aem' : 'lumina';
      runner = ok(want) ? want : inPlay('touch')[0] || null;
      kind = 'other';
    }
    if (!runner && better.length) { runner = top(better); kind = 'hint'; }
    if (!runner) {
      const others = under.filter((k) => k !== match);
      if (others.length) runner = top(others);
      else { const up = all.filter((k) => pos(k) > pos(match)); runner = up[0] || all.filter((k) => k !== match)[0] || null; }
    }
    return { match, runner, kind, cap, capDecided, skipped1 };
  };
  const reasons = (r) => {
    const c = COPY[r.match];
    const out = [];
    const add = (t) => { if (t && out.length < 3 && out.indexOf(t) < 0) out.push(t); };
    if (r.skipped1 && DATA[r.match].group === 'hands') add(TRIAL);
    if (r.capDecided && c.budget && r.cap) add(c.budget.replace('{cap}', kr(r.cap)));
    const g = group();
    const given = ['q2', 'q3'].filter((q) => a[q] && a[q] !== SKIP && c.lines[a[q]])
      .map((q, i) => ({ v: a[q], p: ((POINTS[q + (g === 'touch' ? 't' : 'h')][a[q]] || {})[r.match]) || 0, i }))
      .sort((x, y) => y.p - x.p || x.i - y.i);
    given.forEach((x) => add(c.lines[x.v][0]));
    given.forEach((x) => add(c.lines[x.v][1]));
    c.defaults.forEach(add);
    return out;
  };

  /* ---------- drawing ---------- */
  const CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.2 4L19 7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  const PEN = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 10h2l5.5-5.5-2-2L2 8z" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  const label = (i) => {
    const v = a['q' + (i + 1)];
    if (v === undefined || v === SKIP) return null;
    if (i === 3) return v === 'any' ? 'Ingen fast ramme' : 'Op til ' + kr(v);
    const o = Q[qKey(i)].opts.find((x) => x[0] === v);
    return o ? o[1] : null;
  };
  const drawQuestion = () => {
    const key = qKey(step);
    const isBudget = step === 3;
    const cur = a['q' + (step + 1)];
    let opts;
    let title;
    let sub = '';
    if (isBudget) {
      title = 'Hvad må den højst koste?';
      opts = caps().map((c) => [c, 'Op til ' + kr(c), '']).concat([['any', 'Ingen fast ramme', '']]);
      if (group() === 'touch' && inPlay('touch').length) sub = 'Maskinerne med ét tryk koster fra ' + kr(Math.min(...inPlay('touch').map((k) => DATA[k].price))) + '.';
    } else { title = Q[key].title; opts = Q[key].opts; }
    const prog = [0, 1, 2, 3].map((i) => '<i' + (i <= step ? ' class="on"' : '') + '></i>').join('');
    quiz.innerHTML = '<div class="q8-scr"><div class="q8-top">'
      + (step > 0 ? '<button class="q8-back" type="button" data-af-back><span aria-hidden="true">‹</span> Tilbage</button>' : '')
      + '<span class="eyebrow">Spørgsmål ' + (step + 1) + ' af 4</span><button class="q8-skip" type="button" data-af-skip>Spring over</button></div>'
      + '<div class="q8-prog" aria-hidden="true">' + prog + '</div>'
      + '<h3 class="af-q" id="af-q" tabindex="-1">' + esc(title) + '</h3>' + (sub ? '<p class="af-qsub">' + esc(sub) + '</p>' : '')
      + '<div class="af-chips' + (opts.length === 4 ? ' af-chips--4' : '') + '" role="radiogroup" aria-labelledby="af-q">'
      + opts.map((o) => '<button class="q8-chip' + (cur === o[0] ? ' on' : '') + '" type="button" role="radio" aria-checked="' + (cur === o[0]) + '" data-af-opt="' + esc(o[0]) + '">' + esc(o[1]) + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</button>').join('')
      + '</div>'
      + (step === 0 ? '<div class="af-more"><button class="link af-more__btn" type="button" aria-expanded="' + moreOpen + '" aria-controls="af-more" data-af-more>Hvad er forskellen?</button><p class="af-more__tx" id="af-more"' + (moreOpen ? '' : ' hidden') + '>' + esc(Q.q1.more) + '</p></div>'
        + '<p class="af-empty">Svar på fire korte spørgsmål, så viser AIVIQ den maskine, der passer til dine svar, og én mere at kigge på.</p>' : '')
      + '</div>';
  };
  const drawResult = () => {
    const r = compute();
    const m = DATA[r.match];
    const c = COPY[r.match];
    const chips = [0, 1, 2, 3].map((i) => { const l = label(i); return l ? '<button class="q8-ans" type="button" aria-label="Ret: ' + esc(l) + '" data-af-edit="' + i + '">' + esc(l) + PEN + '</button>' : ''; }).join('');
    let alt = '';
    if (r.runner) {
      const o = DATA[r.runner];
      const d = o.price - m.price;
      const diff = d > 0 ? ' · +' + kr(d) : d < 0 ? ' · ' + kr(-d) + ' mindre' : '';
      if (r.kind === 'hint') alt = '<b>Passer endnu bedre, over dit budget</b> ' + esc(o.name) + ' passer endnu bedre til dine svar, men koster ' + o.priceText + '. Den har ' + COPY[r.runner].step + '.';
      else if (r.kind === 'other') alt = '<b>Vil du hellere have hele koppen på ét tryk?</b> Se <a class="link" href="' + esc(o.url) + '">' + esc(o.name) + '</a> · ' + o.priceText + '. Den har 30 dages returret, men ikke hjemmeprøven.';
      else alt = '<b>Kig også på <a href="' + esc(o.url) + '">' + esc(o.name) + '</a></b>' + diff + '. ' + (c.also[r.runner] || 'Den har ' + COPY[r.runner].step + '.');
    }
    const trust = m.group === 'hands' ? (r.skipped1 ? TRUST.hands[1] : TRUST.hands.join(' ')) : TRUST.touch;
    quiz.innerHTML = '<div class="af-ans"><span class="eyebrow">Dine svar</span><div class="af-ans__list">' + chips + '</div><button class="link af-ans__reset" type="button" data-af-reset>Start forfra</button></div>'
      + '<div class="q8-res" tabindex="-1" data-af-res><span class="q8-tab">Dit match</span>'
      + '<span class="af-res__img"><img src="' + esc(m.img) + '" alt="' + esc(m.name) + '"></span>'
      + '<div class="af-res__main"><div class="af-res__id"><span class="af-res__name">' + esc(m.name) + '</span><span class="af-res__type">' + esc(m.type) + '</span><span class="af-res__price">' + m.priceText + '<span>' + esc(m.note) + '</span></span></div>'
      + '<p class="af-res__why"><span class="eyebrow">Derfor passer den</span>' + esc(c.why) + '</p>'
      + reasons(r).map((t) => '<div class="q8-ck">' + CHECK + '<span>' + esc(t) + '</span></div>').join('')
      + '<p class="af-res__good"><b>Godt at vide:</b> ' + esc(c.good(a)) + '</p></div>'
      + '<div class="af-res__side">' + (alt ? '<p class="af-res__alt">' + alt + '</p>' : '')
      + '<div class="af-res__btns"><a class="btn btn-dark" href="' + esc(m.url) + '">Se ' + esc(m.name) + '</a>' + (m.available && m.variant ? '<button class="btn btn-outline" type="button" data-af-add="' + m.variant + '">Læg i kurv</button>' : '') + '</div>'
      + '<div class="af-res__links"><button class="link" type="button" data-af-edit="3">Ret svar</button><a class="link" href="#sammenlign-alle-seks">Sammenlign alle seks <span aria-hidden="true">↓</span></a></div>'
      + '<p class="af-res__trust">' + esc(trust) + '</p>'
      + (m.group === 'touch' ? '<p class="af-res__quiet">Vil du hellere lave espressoen selv? Se <a href="#sammenlign-alle-seks" data-af-seg-link="hands">Aspire-serien</a>, som du kan prøve derhjemme i 30 dage.</p>' : '')
      + '</div></div>';
    mark(r.match);
    showGroup(m.group);
    track('aiviq_finder_result', { path: group(), match: r.match, runner_up: r.runner, budget: r.cap || a.q4 || null, hint: r.kind === 'hint' });
    try { sessionStorage.setItem('aiviq-finder', JSON.stringify({ a, mem })); } catch (e) {}
  };

  /* ---------- the comparison: the ring on the match, the group switch ---------- */
  const TAB = '<span class="q8-cardtab">Dit match</span>';
  const mark = (key) => {
    root.querySelectorAll('[data-af-card]').forEach((card) => {
      const on = card.getAttribute('data-af-card') === key;
      card.classList.toggle('q8-ring', on);
      const slot = card.querySelector('[data-af-tab]');
      if (!slot) return;
      if (slot.dataset.afRest === undefined) slot.dataset.afRest = slot.innerHTML;
      slot.innerHTML = on ? TAB : slot.dataset.afRest;
      /* phones: the match comes first in its row */
      const rail = card.closest('[data-af-rail]');
      if (rail && on && rail.firstElementChild !== card) rail.insertBefore(card, rail.firstElementChild);
    });
  };
  const showGroup = (g) => {
    root.querySelectorAll('[data-af-group]').forEach((el) => { el.hidden = el.getAttribute('data-af-group') !== g; });
    root.querySelectorAll('[data-af-seg]').forEach((b) => { const on = b.getAttribute('data-af-seg') === g; b.classList.toggle('on', on); b.setAttribute('aria-selected', String(on)); });
  };
  /* a group without machines in the shop has no switch */
  if (!inPlay('touch').length && !Object.keys(DATA).some((k) => DATA[k].group === 'touch' && DATA[k].ok)) { const seg = root.querySelector('.q8-seg'); if (seg) seg.hidden = true; }

  /* ---------- moving on ---------- */
  const draw = (focus) => {
    if (step >= 4) drawResult(); else drawQuestion();
    if (focus) { const el = quiz.querySelector(step >= 4 ? '[data-af-res]' : '#af-q'); if (el) el.focus({ preventScroll: true }); }
  };
  const next = () => {
    /* go to the first question that has no answer yet (after an edit the rest is kept) */
    let i = 0;
    while (i < 4 && a['q' + (i + 1)] !== undefined) i++;
    step = i;
    draw(true);
    if (step >= 4) {
      const res = quiz.querySelector('[data-af-res]');
      const top = quiz.getBoundingClientRect().top;
      if (res && (top < 0 || top > window.innerHeight * 0.6)) window.scrollTo({ top: Math.max(0, top + window.scrollY - 120), behavior: 'auto' });
    }
  };
  const answer = (v) => {
    const i = step;
    const key = 'q' + (i + 1);
    if (i === 0) {
      const before = group();
      mem[before] = { q2: a.q2, q3: a.q3, q4: a.q4 };
      a.q1 = v;
      const now = group();
      if (now !== before) { a.q2 = mem[now].q2; a.q3 = mem[now].q3; a.q4 = mem[now].q4; }
    } else a[key] = i === 3 && v !== 'any' && v !== SKIP ? Number(v) : v;
    /* a cap that no longer exists in this branch is asked again */
    if (typeof a.q4 === 'number' && caps().indexOf(a.q4) < 0) a.q4 = undefined;
    track('aiviq_finder_answer', { q: i + 1, value: v });
    next();
  };
  quiz.addEventListener('click', (e) => {
    const t = e.target.closest('button, a');
    if (!t || !quiz.contains(t)) return;
    if (t.hasAttribute('data-af-opt')) {
      quiz.querySelectorAll('[data-af-opt]').forEach((b) => { const on = b === t; b.classList.toggle('on', on); b.setAttribute('aria-checked', String(on)); });
      const v = t.getAttribute('data-af-opt');
      setTimeout(() => answer(v), 260);
    } else if (t.hasAttribute('data-af-skip')) answer(SKIP);
    else if (t.hasAttribute('data-af-back')) { step = Math.max(0, step - 1); draw(true); }
    else if (t.hasAttribute('data-af-more')) { moreOpen = !moreOpen; t.setAttribute('aria-expanded', String(moreOpen)); quiz.querySelector('#af-more').hidden = !moreOpen; }
    else if (t.hasAttribute('data-af-edit')) { step = Number(t.getAttribute('data-af-edit')); a['q' + (step + 1)] = a['q' + (step + 1)] === SKIP ? undefined : a['q' + (step + 1)]; drawQuestion(); const h = quiz.querySelector('#af-q'); if (h) h.focus({ preventScroll: true }); }
    else if (t.hasAttribute('data-af-reset')) { a = {}; mem.hands = {}; mem.touch = {}; step = 0; mark(null); showGroup('hands'); try { sessionStorage.removeItem('aiviq-finder'); } catch (x) {} draw(true); }
    else if (t.hasAttribute('data-af-seg-link')) showGroup(t.getAttribute('data-af-seg-link'));
    else if (t.hasAttribute('data-af-add')) addToCart(t);
  });
  /* editing a question that already has an answer: picking again returns to the result */
  root.querySelectorAll('[data-af-seg]').forEach((b) => b.addEventListener('click', () => showGroup(b.getAttribute('data-af-seg'))));

  /* »Læg i kurv«: the cart drawer opens as on the rest of the site */
  const addToCart = async (btn) => {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-af-add')), quantity: 1 }] }),
      });
      const data = await res.json();
      if (!res.ok) throw data;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn } }));
    } catch (x) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', { bubbles: true, detail: { errorMessage: x && x.description } }));
    } finally { btn.removeAttribute('aria-busy'); }
  };

  /* FAQ under the comparison */
  root.querySelectorAll('.af-faq .faq').forEach((btn) => {
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
      const path = btn.querySelector('svg path');
      if (path) path.setAttribute('d', open ? 'M2 8h12' : 'M8 2v12M2 8h12');
    });
  });

  /* start: a result from this visit is shown again (back from a product page) */
  try {
    const saved = JSON.parse(sessionStorage.getItem('aiviq-finder') || 'null');
    if (saved && saved.a) { a = saved.a; Object.assign(mem, saved.mem || {}); if (typeof a.q4 === 'number' && caps().indexOf(a.q4) < 0) a.q4 = 'any'; step = 4; }
  } catch (e) {}
  if (step >= 4 && [1, 2, 3, 4].every((n) => a['q' + n] !== undefined)) drawResult(); else { step = 0; drawQuestion(); }
})();
